import { memo } from "react";

import { useClassName } from "./use-class-name";
import { useDayRender } from "./use-day-render";

import type { CalendarDayType } from "../../root/use-initialize/utils";

type Props = {
	dayRangeItem: CalendarDayType;
};

export const Day = memo(({ dayRangeItem }: Props) => {
	const dayRender = useDayRender();
	const className = useClassName(dayRangeItem);

	return (
		<button key={dayRangeItem.fullDate} value={dayRangeItem.fullDate} className={className} {...dayRender}>
			{dayRangeItem.date}
		</button>
	);
});

Day.displayName = "Day";
